import React from "react"

export const currentDateRangeContext = React.createContext()